<div [formGroup]="parentGroup">
    <mat-form-field appearance="fill" [ngClass]="{'invisible':formElement.hidden === 'true'}">
        <mat-label>
            {{ formElement.text }}
        </mat-label>

        <mat-select disableOptionCentering [formControlName]="formElement.formControl">
            <ng-container *ngIf="dropdownListOptions | async as dropdownListOptions">
                <mat-option></mat-option>
                <ng-container *ngFor="let option of dropdownListOptions.data">
                    <mat-option *ngIf="isCurrentLookupItem(option.endDate)" [value]="option.id">{{ option.text }}</mat-option>
                </ng-container>
            </ng-container>
        </mat-select>
    </mat-form-field>
</div>
